export const TodoList = "todoList";
export const SupportList = "supportList";
export const DocumentDraftList = "ddList";
export const LatestInvoiceList = "lIList";
export const ArticleInvoiceList = "aIList";
export const CustomerRefernceList = "cRList";
export const MoreActionColumnProperty = "moreActionColumn";
